import CloudSync from "@material-symbols/svg-500/rounded/cloud_sync.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const CloudSyncIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: CloudSync });
	return <Icon />;
};

export default memo(CloudSyncIcon);
